import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from 'yup';
import toast, { Toaster } from 'react-hot-toast';
import { useCreateCategoryMutation, useUpdateCategoryMutation } from "../../core/redux/api/productApi";
const categorySchema = Yup.object().shape({
  name: Yup.string().required('Category name is required'),
  Image: Yup.mixed()
});

const AddCategoryModal = ({ isEdit = false, categoryData = null, onSuccess }) => {
    const [createCategory] = useCreateCategoryMutation();
    const [updateCategory] = useUpdateCategoryMutation();
  const formik = useFormik({
    initialValues: {
      name: '',
      Image: null
    },
    validationSchema: categorySchema,
    onSubmit: async (values, { setSubmitting }) => {
        const formData = new FormData();  
        formData.append('name', values.name);
        if (values.Image) {
          formData.append('Image', values.Image);
        
        }

        const saveOperation = isEdit && categoryData 
        ? () => updateCategory({ id: categoryData._id, formData }).unwrap()
        : () => createCategory(formData).unwrap();
        
     
        try {
          await toast.promise(
            saveOperation(),
            {
              loading: 'Saving category...',
              success: 'Category saved successfully!',
              error: (err) => {
                console.error('Error saving category:', err);
                return err.data?.message || 'Could not save category';
              }
            }
          );
          onSuccess(); // Call success callback only if promise resolves
          document.querySelector('[data-bs-dismiss="modal"]').click(); 
        } catch (error) {
          // Error is already handled by toast.promise
        } finally {
          setSubmitting(false);
        }
      
    }
  });

  useEffect(() => {
    if (isEdit && categoryData) {
      formik.setValues({
        name: categoryData.name || '',
        Image: categoryData.thumbnail || null
      });
    } else {
      formik.resetForm();
    }
  }, [isEdit, categoryData]);

  return (
    <div className="modal fade" id="add-category">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header">
                <div className="page-title" id="modal-body">
                  <h4>{isEdit ? 'Edit Category' : 'Add Category'}</h4>
                </div>
                <button
                  type="button"
                  className="close bg-danger text-white fs-16"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => formik.resetForm()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">
                      Category Name<span className="text-danger ms-1">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${formik.touched.name && formik.errors.name ? 'is-invalid' : ''}`}
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="invalid-feedback">{formik.errors.name}</div>
                    )}
                  </div>

                <div className="mb-3">
  <label className="form-label">
    Category Image
  </label>
  <input
    type="file"
    className={`form-control ${formik.touched.Image && formik.errors.Image ? 'is-invalid' : ''}`}
    name="Image"
    accept="image/png, image/jpeg"
    onChange={(event) => {
      formik.setFieldValue("Image", event.currentTarget.files[0]);
      formik.setFieldTouched("Image", true);
    }}
    onBlur={formik.handleBlur}
  />
  {formik.touched.Image && formik.errors.Image ? (
    <div className="invalid-feedback">{formik.errors.Image}</div>
  ) : null}
  {isEdit && categoryData?.thumbnail && (
    <div className="mt-2">
      <img 
        src={categoryData.thumbnail} 
        alt="Current thumbnail" 
        style={{ width: 50, height: 50 }} 
      />
      <small className="d-block text-muted">Current image</small>
    </div>
  )}
</div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                      data-bs-dismiss="modal"
                      onClick={() => formik.resetForm()}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary fs-13 fw-medium p-2 px-3"
                      type="submit"
                      disabled={formik.isSubmitting}
                        //  data-bs-dismiss="modal"

                    >
                      {formik.isSubmitting ? 'Processing...' : isEdit ? 'Update Category' : 'Add Category'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
   
    </div>
  );
};

export default AddCategoryModal;